import { useEffect, useState } from "react";
import PubSub from "../../services/PubSub";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const InfoModal = () => {
    const [translate] = useTranslation();
    const [show, setShow] = useState(false);
    const [info, setInfo] = useState("");
    const [title, setTitle] = useState("OTM_ERROR");
    const [extraInfo, setExtraInfo] = useState("");

    useEffect(() => {
        const showId = PubSub.subscribe("show_info", (error, title, shouldTranslate = true, errorSubCode) => {
            setInfo(shouldTranslate ? translate(error) : error);
            setExtraInfo(translate(errorSubCode));
            if (title) {
                setTitle(title);
            }
            setShow(true);
        });

        return () => {
            PubSub.unsubscribe("show_info", showId);
        }
    }, [translate]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate(title)}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <label>{info}</label>
                <label className='d-block'>{extraInfo}</label>
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button onClick={() => setShow(false)} variant="secondary" className="btn-sm">{translate("OTM_CLOSE")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default InfoModal;
